import {
    VALIDATE_OTP,
    VALIDATE_OTP_SUCCESS,
    VALIDATE_OTP_FAIL,
} from '../action/validateOtpAction'
import { api_err_msg } from "../strings.json"

const initialState = {
    apiState: "", // loading, success, error
    message: "",
    data: {},
}

export default function (state = initialState, action) {
    switch (action.type) {
        case VALIDATE_OTP:
            return {
                ...state,
                apiState: "loading",
            }

        case VALIDATE_OTP_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data,
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }

        case VALIDATE_OTP_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response.data.message
            }

        default:
            return state
    }
}
